import { ReviewsAutoReplyProgress, ReviewsExportProgress } from '@/context/reviews-page.types';

export const formatEtaDuration = (seconds: number): string => {
    if (seconds <= 0) {
        return '< 1с';
    }

    const rounded = Math.max(1, Math.round(seconds));
    const mins = Math.floor(rounded / 60);
    const secs = rounded % 60;

    if (!mins) {
        return `${secs}с`;
    }

    if (mins < 60) {
        return `${mins}м ${secs.toString().padStart(2, '0')}с`;
    }

    const hours = Math.floor(mins / 60);
    const restMins = mins % 60;

    return `${hours}ч ${restMins.toString().padStart(2, '0')}м`;
};

export const toPercent = (completed: number, total: number | null): number | null => {
    if (!total || total <= 0) {
        return null;
    }

    return Math.max(0, Math.min(100, Math.round((completed / total) * 100)));
};

export type ExportProgressSummary = {
    socketUnavailable: boolean;
    displayedProcessed: number;
};

export const summarizeExportProgress = (progress: ReviewsExportProgress): ExportProgressSummary => ({
    socketUnavailable: !progress.isProgressAvailable,
    displayedProcessed:
        progress.totalRows !== null ? Math.min(progress.processedRows, progress.totalRows) : progress.processedRows,
});

export type AutoReplyProgressSummary = {
    displayedProcessed: number;
    isFailed: boolean;
    isCanceled: boolean;
};

export const summarizeAutoReplyProgress = (progress: ReviewsAutoReplyProgress): AutoReplyProgressSummary => ({
    displayedProcessed: Math.min(progress.processed, progress.total),
    isFailed: progress.terminalStage === 'failed',
    isCanceled: progress.terminalStage === 'canceled',
});
